import { Path } from "~/v2/path";
import type {
  AccountStatusMapFunction,
  AccountStatusProps,
} from "./AccountStatusMap";

export const Active = ({
  account,
  margin,
}: AccountStatusProps): ReturnType<AccountStatusMapFunction> => {
  const isBannerDisplayed =
    !!margin &&
    Number(margin?.effective_buying_power ?? 0) === 0 &&
    Number(margin?.non_marginable_buying_power ?? 0) === 0;

  if (!isBannerDisplayed) {
    return null;
  }

  if (account?.account_type === "ira") {
    return {
      message: "Your IRA account is active!",
      button: {
        text: "Transfer Now",
        to: Path.ROUTE_PORTFOLIO_TRANSFER,
      },
    };
  }

  return {
    variant: "success",
    message: "Ready to fund!",
    button: {
      text: "Fund your account →",
      to: Path.ROUTE_FUNDING,
    },
  };
};
